import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { routerMiddleware } from "react-router-redux";
import reducer from "./modules";
import { addDevTools, enableReducerHotReload } from "./store.devtools";
import { analyticsMiddleware } from "./middleware/analytics";

export default (history, state) => {
  const middlewares = [routerMiddleware(history), thunk, analyticsMiddleware];

  const enhancers = addDevTools(applyMiddleware(...middlewares));

  const store = createStore(reducer, state, enhancers);

  enableReducerHotReload(store);

  return store;
};
